import React, { useEffect, useState, memo } from 'react';
export const AnnouncementBar = memo(function AnnouncementBar() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const banners = ['Summer Offers - DISCOUNTS UP TO 80% | Limited time!', 'Free Shipping on Orders Over $50 | Shop Now', 'New Arrivals - Check Out Our Latest Products'];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-blue-50 text-gray-800 md:hidden" data-id="element-2677" data-mp="ve3m7uubowzi">
      <div className="container mx-auto px-4" data-id="element-2678" data-mp="10c54wenu6uag">
        <div className="relative h-9 overflow-hidden" data-id="element-2679" data-mp="10bd8j1mf0sj4">
          {banners.map((text, index) => <div key={index} className={`absolute inset-0 flex items-center justify-center text-center text-sm font-medium transition-opacity duration-500 ${currentBanner === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-2680" data-mp="15d2omvohvwe2" data-mpi={index}>
              {text}
            </div>)}
        </div>
      </div>
      <div className="bg-gradient-to-r from-[#fdc300] to-blue-200 h-0.5" data-id="element-2681" data-mp="w9kjwk6ozcdk"></div>
    </div>;
});